import React, { useState } from 'react';
import { useTeam } from './TeamContext';

const Welcome = () => {
  const { team } = useTeam();

  return (
    <div className="mt-4">
      <h2 className="font-lustra text-3xl text-white text-center mb-6">
        Bienvenidos "<span className="font-bold">{team.name}</span>"!
      </h2>
      <div className="mt-2 mb-2 text-lg space-y-4 text-white">
        <p>
          Han llegado a los confines de la galaxia <span className="font-bold">{team.galaxy_name}</span>,
          un lugar donde los pagos intergalácticos fluyen como estrellas en el vasto universo.
          Pero cuidado, este territorio no es solo majestuoso, también está lleno de desafíos
          que pondrán a prueba sus habilidades para mantener las transacciones a raya.
        </p>
        <p>
          Su misión será clara pero peligrosa: controlar los flujos de pago,
          evitar colisiones de transacciones, y prevenir las anomalías que podrían
          desestabilizar el equilibrio intergaláctico.
        </p>
        <p>
          Cada decisión que tomen y cada acción que realicen serán críticas
          para evitar los peligros de los pagos errantes, las distorsiones espacio-tiempo
          y garantizar que el comercio entre galaxias siga siendo próspero.
        </p>
        <p>
          Solo los equipos más ágiles, estratégicos y unidos lograrán navegar por estas aguas
          cósmicas sin sucumbir al caos. Así que ajusten sus coordenadas, afilen sus herramientas, y
          prepárense para sumergirse en la aventura de <span className="font-bold">Galactic Payments</span>.
        </p>
        <p>
          ¡Que comience el viaje intergaláctico! 🚀
        </p>
      </div>
    </div>
  );
};

export default Welcome;
